/**
 * Parseo defensivo de fechas (ISO, ms, Firestore Timestamp / plain { seconds }).
 * Evita RangeError al llamar toISOString sobre Invalid Date.
 */

export function toSafeDate(value) {
  if (value == null || value === '') return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value?.toDate === 'function') {
    const d = value.toDate();
    return Number.isNaN(d.getTime()) ? null : d;
  }

  if (typeof value === 'object') {
    const sec = value.seconds ?? value._seconds;
    if (sec != null && sec !== '') {
      const ns = value.nanoseconds ?? value._nanoseconds ?? 0;
      const d = new Date(Number(sec) * 1000 + Math.floor(Number(ns) / 1e6));
      return Number.isNaN(d.getTime()) ? null : d;
    }
    return null;
  }

  if (typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  if (typeof value === 'string') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  return null;
}

export function toSafeISOString(value) {
  const d = toSafeDate(value);
  return d ? d.toISOString() : null;
}

export function formatSafeDate(value, fallback = 'Sin fecha') {
  const d = toSafeDate(value);
  if (!d) return fallback;
  return d.toLocaleDateString('es-AR');
}

export function formatYmd(value) {
  const d = toSafeDate(value);
  if (!d) return '';
  return d.toISOString().slice(0, 10);
}

export function formatLocaleEs(value, options) {
  const d = toSafeDate(value);
  if (!d) return '—';
  return d.toLocaleString('es-AR', options);
}

/** Vigencia de licencia para UI — nunca devuelve "Invalid Date". */
export function formatLicenseVigencia(raw, fallback = 'Sin vigencia activa') {
  const d = toSafeDate(raw);
  if (!d) return fallback;
  return d.toLocaleDateString('es-AR', { day: 'numeric', month: 'short', year: 'numeric' });
}
